import React from "react";

export const PaginationButtons = ({
	total,
	currentPage,
	onPageChange,
	itemsPerPage,
}) => {
	const pageCount = Math.ceil(total / itemsPerPage);

	if (pageCount <= 1) return null;

	// Determine which pages to show (show at most 5 pages + first/last)
	const getVisiblePages = () => {
		// Always show max 7 items (including prev/next)
		const maxVisiblePages = 5;
		let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
		const endPage = Math.min(pageCount, startPage + maxVisiblePages - 1);

		// Adjust if we're near the end
		if (endPage - startPage < maxVisiblePages - 1) {
			startPage = Math.max(1, endPage - maxVisiblePages + 1);
		}

		const pages = [];

		// Add first page if not already in range
		if (startPage > 1) {
			pages.push(1);
			if (startPage > 2) {
				pages.push("ellipsis-start");
			}
		}

		// Add visible page numbers
		for (let i = startPage; i <= endPage; i++) {
			pages.push(i);
		}

		// Add last page if not already in range
		if (endPage < pageCount) {
			if (endPage < pageCount - 1) {
				pages.push("ellipsis-end");
			}
			pages.push(pageCount);
		}

		return pages;
	};

	const visiblePages = getVisiblePages();

	const renderPageButton = (page, index) => {
		// Handle ellipsis
		if (typeof page === "string" && page.includes("ellipsis")) {
			return (
				<span
					key={page}
					className="px-3 py-1 text-[var(--color-text-secondary)]"
				>
					…
				</span>
			);
		}

		const isActive = currentPage === page;

		return (
			<button
				key={index}
				onClick={() => onPageChange(page)}
				className={`
          px-3 py-1 rounded text-sm
          border transition-colors duration-150
          ${
						isActive
							? "bg-[var(--color-accent)] border-[var(--color-accent)] font-medium text-[var(--color-accent-contrast)]"
							: "bg-[var(--color-bg-primary)] text-[var(--color-text-primary)] border-[var(--color-border)] hover:border-[var(--color-border-hover)] hover:bg-[var(--color-bg-hover)]"
					}
        `}
				aria-current={isActive ? "page" : undefined}
			>
				{page}
			</button>
		);
	};

	return (
		<div className="flex justify-center items-center gap-2 mt-4">
			{visiblePages.map(renderPageButton)}
		</div>
	);
};
